// extracted by mini-css-extract-plugin
export var centered = "_i-6";
export var flexible = "_i-5";
export var footer = "_i-k";
export var footerBorder = "_i-l";
export var header = "_i-c";
export var headerBorder = "_i-d";
export var headerDefault = "_i-g";
export var headerMedium = "_i-h";
export var headerPadding = "_i-e";
export var iconAndTitle = "_i-f";
export var large = "_i-4";
export var largePadding = "_i-a";
export var medium = "_i-3";
export var mediumPadding = "_i-9";
export var modal = "_i-0";
export var modalContainer = "_i-b";
export var noPadding = "_i-7";
export var skinny = "_i-1";
export var small = "_i-2";
export var smallPadding = "_i-8";
export var subtitle = "_i-j";
export var title = "_i-i";